import { useEffect, useRef, useState } from 'react';

const practicalSessions = [
  {
    no: 1,
    speaker: 'DR.FATİH RASİM',
    topic: 'ANTERİOR KIRIKLARIN ESTETİK VE FONKSİYONEL RESTORASYONU KOMPOZİT METERYALLER İLE DİASTEMA KAPATMA',
    dateTime: '3 MAYIS 2026 ÖĞLEDEN ÖNCE',
    capacity: '20 Kişi',
  },
  {
    no: 2,
    speaker: 'DT.EMRECAN EREN',
    topic: 'KLİNİK DİJİTAL İŞ AKIŞINDA 3D PRİNTER İLE ÜRETİLEN GEÇİCİ VE DAİMİ RESTORASYONLAR',
    dateTime: '3 MAYIS 2026 ÖĞLEDEN ÖNCE',
    capacity: '20 Kişi',
  },
  {
    no: 3,
    speaker: 'DOÇ.DR.AYFER ATAV & DR.EMRE ÖVSAY',
    topic: 'RISING: ENDODONTİK ŞEKİLLENDİRMEDE YENİ BİR EVRİM',
    dateTime: '3 MAYIS 2026 ÖĞLEDEN ÖNCE',
    capacity: '20 Kişi',
  },
  {
    no: 4,
    speaker: 'PROF.DR.EZHER DAYISOYLU',
    topic: 'TEMEL İMPLANTOLOJİ',
    dateTime: '3 MAYIS 2026 ÖĞLEDEN ÖNCE',
    capacity: '20 Kişi',
  },
  {
    no: 5,
    speaker: 'DT.SELİM CAN DÖNEL',
    topic: 'DİŞ HEKİMLİĞİ KLİNİĞİNDE BOTULİNUM TOKSİN UYGULAMALARI',
    dateTime: '3 MAYIS 2026 ÖĞLEDEN SONRA',
    capacity: '20 Kişi',
  },
  {
    no: 6,
    speaker: 'DR.FATİH RASİM',
    topic: 'ANTERİOR KIRIKLARIN ESTETİK VE FONKSİYONEL RESTORASYONU KOMPOZİT METERYALLER İLE DİASTEMA KAPATMA',
    dateTime: '3 MAYIS 2026 ÖĞLEDEN SONRA',
    capacity: '20 Kişi',
  },
  {
    no: 7,
    speaker: 'DOÇ.DR.AYFER ATAV & DR.EMRE ÖVSAY',
    topic: 'RISING: ENDODONTİK ŞEKİLLENDİRMEDE YENİ BİR EVRİM',
    dateTime: '3 MAYIS 2026 ÖĞLEDEN SONRA',
    capacity: '20 Kişi',
  },
  {
    no: 8,
    speaker: 'PROF.DR.EZHER DAYISOYLU',
    topic: 'TEMEL İMPLANTOLOJİ',
    dateTime: '3 MAYIS 2026 ÖĞLEDEN SONRA',
    capacity: '20 Kişi',
  },
];

const PracticalSessions = () => {
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const [isMorningVisible, setIsMorningVisible] = useState(true);
  const [isAfternoonVisible, setIsAfternoonVisible] = useState(true);
  const [visibleMorningRows, setVisibleMorningRows] = useState<number[]>([0,1,2,3,4]);
  const [visibleAfternoonRows, setVisibleAfternoonRows] = useState<number[]>([0,1,2]);

  const headerRef = useRef<HTMLDivElement>(null);
  const morningRef = useRef<HTMLDivElement>(null);
  const afternoonRef = useRef<HTMLDivElement>(null);

  const morningRows = practicalSessions.filter((s) => s.dateTime.includes('ÖNCE'));
  const afternoonRows = practicalSessions.filter((s) => s.dateTime.includes('SONRA'));

  useEffect(() => {
    setIsHeaderVisible(true);
    setIsMorningVisible(true);
    setIsAfternoonVisible(true);
    setVisibleMorningRows(morningRows.map((_, i) => i));
    setVisibleAfternoonRows(afternoonRows.map((_, i) => i));
  }, []);

  const renderDesktopRows = (
    rows: typeof practicalSessions,
    startIndex: number,
    visibleRowsArray: number[]
  ) =>
    rows.map((session, index) => (
      <div
        key={session.no}
        className={`grid grid-cols-[60px_1fr_2fr_200px_100px] transition-all duration-700 hover:bg-accent/5 group ${
          (startIndex + index) % 2 === 0 ? 'bg-white' : 'bg-gray-50/60'
        } ${visibleRowsArray.includes(index) ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'}`}
      >
        <div className="px-6 py-5 flex items-center justify-center">
          <span className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary/10 text-secondary font-bold text-sm group-hover:bg-secondary group-hover:text-white transition-all duration-300">
            {session.no}
          </span>
        </div>
        <div className="px-6 py-5 border-l border-gray-100 flex items-center">
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-secondary flex-shrink-0" />
            <span className="font-semibold text-primary text-sm leading-snug">{session.speaker}</span>
          </div>
        </div>
        <div className="px-6 py-5 border-l border-gray-100 flex items-center">
          <p className="text-gray-700 text-sm leading-relaxed font-medium">{session.topic}</p>
        </div>
        <div className="px-6 py-5 border-l border-gray-100 flex items-center">
          <div className="flex items-center gap-2">
            <i className="ri-calendar-line text-secondary text-sm" />
            <span className="text-gray-600 text-xs font-medium leading-snug">{session.dateTime}</span>
          </div>
        </div>
        <div className="px-6 py-5 border-l border-gray-100 flex items-center justify-center">
          <span className="inline-flex items-center gap-1 px-3 py-1.5 bg-secondary/10 text-secondary rounded-full text-xs font-bold whitespace-nowrap">
            <i className="ri-group-line text-xs" />
            {session.capacity}
          </span>
        </div>
      </div>
    ));

  const renderMobileCards = (
    rows: typeof practicalSessions,
    visibleRowsArray: number[],
    groupLabel: string,
    groupIcon: string,
    groupColor: string
  ) => (
    <div className="flex flex-col gap-3">
      <div className={`flex items-center gap-2 px-3 py-2 rounded-lg ${groupColor}`}>
        <i className={`${groupIcon} text-sm`} />
        <span className="font-bold text-xs tracking-widest uppercase">{groupLabel}</span>
      </div>
      {rows.map((session, index) => (
        <div
          key={session.no}
          className={`rounded-xl border border-gray-100 shadow-md bg-white overflow-hidden transition-all duration-500 ${
            visibleRowsArray.includes(index) ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <div className="bg-gradient-to-r from-secondary to-secondary-dark px-4 py-2 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <span className="w-6 h-6 flex items-center justify-center rounded-full bg-white/20 text-white font-bold text-xs">
                {session.no}
              </span>
              <span className="text-white/80 text-xs font-semibold tracking-widest uppercase">Pratik Oturum</span>
            </div>
            <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-white/20 text-white rounded-full text-xs font-bold">
              <i className="ri-group-line text-xs" />
              {session.capacity}
            </span>
          </div>
          <div className="p-4">
            <div className="flex items-start gap-2 mb-2">
              <div className="w-2 h-2 rounded-full bg-secondary flex-shrink-0 mt-1.5" />
              <span className="font-bold text-primary text-sm leading-snug">{session.speaker}</span>
            </div>
            <div className="flex items-start gap-2 mb-3">
              <i className="ri-file-text-line text-secondary text-sm flex-shrink-0 mt-0.5" />
              <p className="text-gray-700 text-sm leading-relaxed">{session.topic}</p>
            </div>
            <div className="flex items-center gap-2 pt-2 border-t border-gray-100">
              <i className="ri-calendar-line text-secondary text-sm" />
              <span className="text-gray-500 text-xs font-medium">{session.dateTime}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <section className="py-12 md:py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        {/* Section Header */}
        <div ref={headerRef} className="flex items-center gap-4 mb-8 md:mb-10">
          <div
            className={`w-1.5 h-12 md:h-14 bg-gradient-to-b from-secondary to-accent rounded-full transition-all duration-700 ${
              isHeaderVisible ? 'opacity-100 scale-y-100' : 'opacity-0 scale-y-0'
            }`}
            style={{ transformOrigin: 'top' }}
          />
          <div>
            <div
              className={`inline-flex items-center gap-2 px-3 py-1 bg-secondary/10 rounded-full mb-2 transition-all duration-700 delay-100 ${
                isHeaderVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4'
              }`}
            >
              <i className="ri-tools-line text-secondary text-sm" />
              <span className="text-secondary font-semibold text-xs tracking-widest uppercase">Uygulamalı Eğitim</span>
            </div>
            <h2
              className={`font-display text-2xl md:text-4xl font-bold text-primary transition-all duration-700 delay-200 ${
                isHeaderVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4'
              }`}
            >
              Pratik Oturumlar
            </h2>
          </div>
        </div>

        {/* DESKTOP TABLE */}
        <div className="hidden md:block rounded-2xl overflow-hidden shadow-xl border border-gray-100">
          <div className="grid grid-cols-[60px_1fr_2fr_200px_100px] bg-gradient-to-r from-secondary to-secondary-dark text-white">
            <div className="px-6 py-4 text-sm font-bold tracking-wider uppercase text-center">S.NO</div>
            <div className="px-6 py-4 text-sm font-bold tracking-wider uppercase border-l border-white/20">KONUŞMACI</div>
            <div className="px-6 py-4 text-sm font-bold tracking-wider uppercase border-l border-white/20">KONU BAŞLIĞI</div>
            <div className="px-6 py-4 text-sm font-bold tracking-wider uppercase border-l border-white/20">TARİH VE SAAT</div>
            <div className="px-6 py-4 text-sm font-bold tracking-wider uppercase border-l border-white/20 text-center">KONTENJAN</div>
          </div>
          <div ref={morningRef}>
            <div className={`grid grid-cols-[60px_1fr_2fr_200px_100px] bg-amber-50 border-y border-amber-100 transition-all duration-700 ${isMorningVisible ? 'opacity-100' : 'opacity-0'}`}>
              <div className="col-span-5 px-6 py-3 flex items-center gap-2">
                <i className="ri-sun-line text-amber-500" />
                <span className="text-amber-700 font-bold text-xs tracking-widest uppercase">Öğleden Önce Oturumları</span>
              </div>
            </div>
            {renderDesktopRows(morningRows, 0, visibleMorningRows)}
          </div>
          <div ref={afternoonRef}>
            <div className={`grid grid-cols-[60px_1fr_2fr_200px_100px] bg-orange-50 border-y border-orange-100 transition-all duration-700 ${isAfternoonVisible ? 'opacity-100' : 'opacity-0'}`}>
              <div className="col-span-5 px-6 py-3 flex items-center gap-2">
                <i className="ri-sun-foggy-line text-orange-500" />
                <span className="text-orange-700 font-bold text-xs tracking-widest uppercase">Öğleden Sonra Oturumları</span>
              </div>
            </div>
            {renderDesktopRows(afternoonRows, morningRows.length, visibleAfternoonRows)}
          </div>
        </div>

        {/* MOBILE CARDS */}
        <div className="md:hidden flex flex-col gap-6">
          <div ref={morningRef}>
            {renderMobileCards(
              morningRows,
              visibleMorningRows,
              'Öğleden Önce Oturumları',
              'ri-sun-line text-amber-500',
              'bg-amber-50 text-amber-700'
            )}
          </div>
          <div ref={afternoonRef}>
            {renderMobileCards(
              afternoonRows,
              visibleAfternoonRows,
              'Öğleden Sonra Oturumları',
              'ri-sun-foggy-line text-orange-500',
              'bg-orange-50 text-orange-700'
            )}
          </div>
        </div>

        {/* Legend */}
        <div className="mt-6 flex flex-wrap items-center gap-4 md:gap-6">
          <div className="flex items-center gap-2 text-gray-500 text-xs">
            <i className="ri-information-line text-secondary" />
            <span>Pratik oturumlar sınırlı kontenjanla sunulmaktadır.</span>
          </div>
          <div className="flex items-center gap-2 text-gray-500 text-xs">
            <i className="ri-group-line text-secondary" />
            <span>Her oturum maksimum <strong>20 kişi</strong> ile gerçekleştirilecektir.</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PracticalSessions;
